<style lang="scss">
.search-btn {
    .ivu-btn {
        border-radius: 0 !important;
    }
}
.ivu-table-cell {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}

// .overflow-show {
//     overflow-y: visible !important;
//     .ivu-table {
//         overflow: visible !important;
//     }
//     .ivu-table-body {
//         overflow-y: visible !important;
//     }
//     table {
//         overflow-y: visible !important;
//     }
// }

.tablelist-table {
    border-radius: 8px;
}

.tablelist-tabs {
    border-bottom: 1px solid #2d8cf0;
    margin-bottom: 10px;

    .vview-button {
        min-width: 120px;
        height: 36px;
        border-radius: 0 !important;
    }
}

.tablelist-searchs {
    padding: 10px 10px 0;
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    border-radius: 8px;

    .vview-formitem {
        margin-bottom: 10px;
    }
}

.tablelist-page {
    margin-top: 15px;
    // margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
}

.tablelist-tools {
    margin-bottom: 5px;

    & > * {
        margin-right: 5px;
    }

    .vview-dropdown {
        position: relative;
    }

    .vview-dropdown-list {
        min-width: 100%;
    }
}

.tablelist-dropdown {
    .vview-dropdownitem:not(:last-child) {
        border-bottom: 1px solid #ddd;
    }
}
.ivu-table-cell {
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>

<template>
	<div >
        <Breadcrumb class="tablelist-header" v-if="title">
			<BreadcrumbItem>{{title}}</BreadcrumbItem>
		</Breadcrumb>
        <div style="position:relative">
            <compSearch @on-update="updateSearch" ref="compsearch"></compSearch>
            <div class="show-search-list">
                <div
                    v-for="(item, index) in dataArray"
                    :key="index"
                    class="search-show-item"
                >   
                    <Tooltip theme="light" :disabled="!item.showMore">
                        <div v-if="item.showMore" slot="content">
                            <p class="search-show-item-tooltip-item" v-for="(labelItem,index) in item.showLabelArray" :key="index" v-html="labelItem.label">{{labelItem.label}}</p>
                        </div>
                        <span class="search-show-item-title">{{ item.label }}:</span>
                        <span
                            class="search-show-item-label"
                            v-if="Array.isArray(item.showLabel)"
                        >
                            <span
                                class="search-show-item-label-item"
                                v-for="(showLabelItem,index) in item.showLabel"
                                :key="index"
                                v-html="showLabelItem.label"
                            >
                                {{ showLabelItem.label }}
                            </span>
                        </span>
                        <span class="search-show-item-label" v-else>
                            <span v-html="item.showLabel">{{ item.showLabel }}</span>
                        </span>
                    </Tooltip>
                    <Icon
                        class="search-show-item-close-icon"
                        type="ios-close"
                        @click="closeSearchItem(item,index)"
                    />
                </div>
            </div>
            <!-- :height="computedHeight" -->
            <Table
                class="test-mixin-table"
                :columns="columns"
                :data="data"
                size="small"
                ref="table"
                @on-sort-change="sortChange"
                @on-selection-change="handleChecked"
                border
                stripe
            ></Table>
            <compSpage
                ref="compSpage"
                class="text-right margin-top-10"
                v-bind="{
                    total,
                    pageSize: formData.rows,
                    current: formData.page,
                }"
                @on-update="updateList"
            ></compSpage>
            <Modal
            class="hidefooter"
            v-model='operate.show'
            :mask-closable='false'
            v-bind="operate"
            :closable="propsclosable">
                <component ref="component" v-if="operate.show" :is="operate.component" @on-closeCloseable="closeCloseable" @on-openCloseable="openCloseable"  @on-close="operate={}" @on-cancel="operate = {}" v-bind="operate" @on-update="updateSearch"/>
                <footer slot="footer" v-show="operate.footer"></footer>
            </Modal>
            <div  v-if="showDel" >
                <compDelModal @on-confirm='batchOpearte' v-bind="operate" @on-close='showDel=false'/>
            </div>
            <template ref="comTemplate" v-if="showPlugins">
                <compModal
                    v-model="modalData.show"
                    v-bind="modalData"
                    @on-confirm="updateList()"
                    :closable="propsclosable"
                >
                    <component
                        v-if="modalData.component"
                        :is="modalData.component"
                        v-bind="modalData"
                        v-on="modalData.on"
                        @on-closeCloseable="closeCloseable"
                        @on-openCloseable="openCloseable"
                        @on-close="modalData = {}"
                        @on-update="updateSearch"
                    />
                </compModal>
                <slot name="plugins"></slot>
            </template>
            <Spin size="large" fix v-if="loading"></Spin>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import compUpload from "@/components/boss/upload";
import compSpage from "@/components/boss/spage";
import compDelModal from "@/components/boss/delModal";
export default {
    components: {
        compSpage,
        compDelModal,
        compUpload,
    },
    data() {
        return {
            title: false,
            data: [],
            checkedId: [],
            loading: false,
            total: 0,
            showDel: false,
            operate: {
                id: null,
                title: "",
                show: false,
                component: null,
            },
            modalData:{
                show: false,
                loading: false,
            },
            showPlugins:false,
            formData: {
                page: 1,
                rows: 10,
                sidx: "id",
                sord: "desc",
            },
            propsclosable: true,
            computedHeight: null,
            domHeightWatcher: null,
            dataArray:[]
        };
    },
    computed: {
    		getContextAttrs() {
            return this.isMixin ? this : this.$attrs;
        },
        ...mapState("boss", ["accounts", "products"]),
        ...mapGetters("boss", ["warehouses"]),
        ...mapGetters("diction", ["getNewProductList"]),
    },
    mounted() {
        window.onresize = this.resizeThrottle(() => {
            // console.log("resize执行一次");
            this.autoComputedTableHeight().then((height) => {
                this.computedHeight = height;
            });
        }, 50);
    },
    beforeDestroy() {
        window.onresize = null;
        clearInterval(this.domHeightWatcher);
    },
    methods: {
        async changeSearch () {
            // this.$nextTick(() => {
                await this.autoComputedTableHeight().then(height => {
                    this.computedHeight = height;
                })
                await this.$nextTick();
            // })
        },
        // 函数节流
        resizeThrottle(func, delay) {
            let prev = Date.now();
            return function () {
                let that = this;
                let arg = arguments;
                let now = Date.now();
                if (now - prev >= delay) {
                    func.apply(that, arg);
                    prev = Date.now();
                }
            };
        },
        async autoComputedTableHeight(params) {
            // 可视区域高度
            let windowHeight = document.body.offsetHeight;
            // console.log("可视区域高度", windowHeight);
            let titleHeight = 0,
                searchHeight = 0,
                compSpageHeight = 0;
            // 等待dom渲染
            await this.$nextTick();
            // await this.$nextTick(async () => {
                // title高度
                if (this.$refs.breadTitle) {
                    titleHeight = this.$refs.breadTitle.$el.offsetHeight;
                    // console.log(
                    //     "breadTitle",
                    //     this.$refs.breadTitle.$el.offsetHeight
                    // );
                }
                if (this.$refs.compspage) {
                    compSpageHeight = this.$refs.compSpage.$el.offsetHeight;
                    // console.log(
                    //     "compSpage",
                    //     this.$refs.compSpage.$el.offsetHeight
                    // );
                }
                // 搜索高度
                if (this.$refs.compsearch) {
                    searchHeight = this.$refs.compsearch.$el.offsetHeight;
                    // console.log(
                    //     "compsearch",
                    //     this.$refs.compsearch.$el.offsetHeight
                    // );
                }
            // });
            let usedHeight =
                windowHeight -
                titleHeight -
                searchHeight -
                compSpageHeight -
                45 -
                50 -
                83 -
                22;
            let rowList = this.$refs.table.$el.querySelectorAll(
                ".ivu-table-row"
            );
            if (!rowList.length) return usedHeight;
            // table数据列的总高度 解决每个row高度不同的问题
            let rowListHeight = 0;
            let rowArray = Array.from(rowList);
            rowArray.map(item => {
                rowListHeight += item.offsetHeight;
            })
            let rowHeight = rowList[0].offsetHeight;
            let tableHeaderHeight = this.$refs.table.$el.querySelector('.ivu-table-header').querySelector('table').offsetHeight;
            let tableHeight = rowListHeight + tableHeaderHeight;
            let resultHeight = 0
            if (tableHeight < usedHeight) {
                // console.log('rowListHeight', rowListHeight)
                resultHeight = tableHeight;
            } else {
                // console.log('usedHeight', usedHeight)
                resultHeight = usedHeight;
            }
            if (resultHeight < rowHeight + tableHeaderHeight) return rowHeight + tableHeaderHeight;
            return resultHeight;
        },
        closeCloseable() {
            // console.log(11111,'close')
            this.propsclosable = false;
        },
        openCloseable() {
            // console.log(222222,'open')
            this.propsclosable = true;
        },
        handleChecked(selection, row) {
            this.checkedId = selection.map((item) => {
                return item.id;
            });
        },
        sortChange({ column, key, order }) {
            this.updateList({ sidx: key, sord: order });
        },
        updateSearch(data) {
        // 展示页面的查询条件
            // console.log(this.$refs.compsearch,'8898999898899')
            if(this.$refs.compsearch && this.$refs.compsearch.propsData && this.$refs.compsearch.propsData.length>0){
                // console.log(1111221121212121212121212)
                this.showSearchSpan(data);
            }
            this.updateList({ ...data, page: 1 });
        },
        showSearchSpan(formData) {
            //  console.log(formData,'search')
            if (!formData) return (this.dataArray = []);

            // console.log(formData.search,'111111')
            // console.log(this.$refs.compsearch,'22222')
            // 遍历所有当前搜索中使用的key
            let dataArray = [];
            Object.keys(formData.search).map((key) => {
                if ((!formData.search[key] && formData.search[key] !== 0) || formData.search[key].length === 0) return;
                
                (this.$refs.compsearch.propsData || []).map((item) => {
                    // 如果不想展示searchTip，需要在渲染设置上添加hideSearchTip = true
                    if (item.key === key && !item.hideSearchTip) {
                        let newItem = { ...item, value: formData.search[key],options:item.value };
                        // console.log(newItem,'88888888')
                        dataArray.push(newItem);
                    }
                    if(item.tag === "timearray" && item.key[0] === key && !item.hideSearchTip){
                        let newItem = { ...item, value: formData.search[item.key[0]]+'~'+formData.search[item.key[1]] };
                        dataArray.push(newItem);
                    }
                });
            });

            // 循环不在search里面的情况
            Object.keys(formData).map((key) => {
                if ((!formData[key] && formData[key] !== 0) || formData[key].length === 0) return;
                (this.$refs.compsearch.propsData || []).map((item) => {
                    if(item.deletetag === 'deletetag' && key === item.key && !item.hideSearchTip){
                        let newItem = { ...item, value: formData[key],options:item.value };
                        dataArray.push(newItem);
                    }
                });
            });

            // console.log(dataArray,'3333');
            dataArray.map((item) => {
                item.showLabel = item.value;
                if(item.text === 'text'){
                    if (item.showLabel.length > 2) {
                        item.showLabelArray = item.showLabel.map(json=>{
                            return { label:json }
                        })
                        item.showLabel = item.showLabel.slice(0,2);
                        item.showLabel += `等${item.showLabelArray.length}项`;
                        item.showMore = true;
                    }else{
                        item.showLabel = item.showLabel.join(',')
                    }
                }
                if (item.tag === "vSelect" || item.tag === "Select") {
                    // console.log(item,'ititititem');
                    if (Array.isArray(item.value)) {
                        item.showLabelArray = item.value.map((valueItem) => {
                            return item.options.filter((optionsItem) => {
                                return optionsItem.value === valueItem;
                            })[0];
                        });
                    } else {
                        return item.showLabel = item.options.filter(optionsItem => {
                            return item.value === optionsItem.value
                        })[0].label;
                    }
                    item.showLabel = "";
                    if (item.showLabelArray.length > 2) {
                        for (let i = 0; i < 2; i++) {
                            item.showLabel +=
                                item.showLabelArray[i].label + ",";
                        }
                        item.showLabel += `等${item.showLabelArray.length}项`;
                        item.showMore = true;
                    } else {
                        item.showLabel = item.showLabelArray;
                    }
                }
            });
            // console.log(dataArray,'dataArray')
            this.dataArray = dataArray;
        },
        closeSearchItem(item,index) {
            
            if(item.tag === "timearray"){
                this.formData.search[item.key[0]] = ''
                this.formData.search[item.key[1]] = ''
                // delete this.formData.search.str
            }
            // console.log(item,'tetetetete')
            // console.log( this.dataArray )
            if(item.deletetag === "deletetag"){
                this.$refs.compsearch[item.key] = '';
            }
            if(item.tag != 'timearray'){
                this.formData.search[this.dataArray[index].key] = "";
            }
            this.dataArray.splice(index, 1);
            
            this.$refs.compsearch.formData = this.formData.search;
            
            // 缓存storage的，掉自身
            this.$refs.compsearch.update(true);
        },
        // 下拉框内容
        getOperateNodes(h, { row }) {
            const operateNodes = [],
                operateTitle = this.$t("global.common.operation");
            this.getOperateNodeMap(row).forEach((item = {}, index) => {
                if (item.show) {
                    if (item.to) {
                        operateNodes.push(
                            <router-link
                                data-vview-module="DropdownItem"
                                props={item}
                            >
                                {item.label}
                            </router-link>
                        );
                    } else if (item.href) {
                        operateNodes.push(
                            <a data-vview-module="DropdownItem" props={item}>
                                {item.label}
                            </a>
                        );
                    } else {
                        operateNodes.push(
                            <div
                                key={index}
                                data-vview-module="DropdownItem"
                                onClick={this.handleOperates.bind(
                                    this,
                                    item.params,
                                    item.operate,
                                    false
                                )}
                            >
                                {item.label}
                            </div>
                        );
                    }
                }
            });
            return (
                <vDropdown
                    placement="bottom-left"
                    trigger="click"
                    class="tablelist-dropdown"
                >
                    <vButton size="small" theme="info">
                        {operateTitle} <vIcon type="arrow-dropdown" />
                    </vButton>
                    <template slot="list" class="text-left">
                        {operateNodes}
                    </template>
                </vDropdown>
            );
        },
        async updateList(data) {
            

            this.loading = true;
            this.formData = Object.assign({}, this.formData, data);
            
            this.checkedId = [];
            const {
                ajaxRequest,
            } = this.getContextAttrs;
            const response = await this.httpList(this.formData).catch((res) => {
                this.loading = false;
                this.$Message.error({
                    content: res.message,
                    duration: 30,
                    closable: true
                });
            });
            if (response) {
                const data = response.data;
                this.loading = false;
                this.data = data.content || [];
                this.total = data.totalElements || 0;
                sessionStorage.set("downloadTotal", this.total);
                this.autoComputedTableHeight().then((height) => {
                    this.computedHeight = height;
                });
            }
            if (typeof ajaxRequest === "function") {
                let params = { ...this.formData };
                if (typeof interceptRequest === "function")
                    params = interceptRequest.call(
                        this,
                        JSON.parse(JSON.stringify(params)),
                        this
                    );
                return ajaxRequest(params)
                    .then((res) => {
                        this.$VMessage.success(res.message);
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true
                        });
                    });
            }
        },
    },
};
</script>



